import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@/shared/ui/buttons/IconButton';

type Props = {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
};

export const Pagination = ({ page, pageSize, total, onPageChange }: Props) => {
  const { t } = useTranslation();
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total === 0) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 px-1 py-2 text-sm text-ink-muted">
      <span>
        {from}–{to} / {total}
      </span>
      <div className="flex items-center gap-2">
        <IconButton
          label={t('ui.prevPage')}
          variant="default"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
        >
          <ChevronLeft className="h-4 w-4" />
        </IconButton>
        <span className="min-w-[80px] text-center text-sm font-medium text-ink-soft">
          {page} / {totalPages}
        </span>
        <IconButton
          label={t('ui.nextPage')}
          variant="default"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
        >
          <ChevronRight className="h-4 w-4" />
        </IconButton>
      </div>
    </div>
  );
};
